/**
 * Detects the device type based on screen width and touch capabilities
 * @returns {'mobile' | 'tablet' | 'desktop'} Device type
 */
export const detectDeviceType = () => {
  const screenWidth = window.screen.width;
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Mobile: Small screens (typically < 768px)
  if (screenWidth < 768) {
    return 'mobile';
  }

  // Tablet: Medium screens with touch capability (768px - 1024px)
  if (screenWidth >= 768 && screenWidth <= 1024 && hasTouch) {
    return 'tablet';
  }

  // Desktop: Large screens or non-touch devices
  return 'desktop';
};

/**
 * Gets additional device information for debugging/analytics
 * @returns {Object} Device information object
 */
export const getDeviceInfo = () => ({
  deviceType: detectDeviceType(),
  screenWidth: window.screen.width,
  screenHeight: window.screen.height,
  hasTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
  userAgent: navigator.userAgent,
  timestamp: Date.now()
});
